import { APICore } from './apiCore'

const api = new APICore()

function getActivities (params) {
  const baseUrl = '/activities'
  return api.get(baseUrl, params)
}

function getActivity (id) {
  const baseUrl = `/activities/${id}`
  return api.get(baseUrl, {})
}

function addActivity (params) {
  const baseUrl = '/activities'
  return api.createWithFile(baseUrl, params)
}

function updateActivity (params) {
  const baseUrl = '/activities'
  return api.updateWithFile(baseUrl, params)
}

function deleteActivity (params) {
  const baseUrl = '/activities'
  return api.delete(baseUrl, params)
}

export { getActivities, getActivity, addActivity, updateActivity, deleteActivity }
